import { render, staticRenderFns } from "./PeddlrOptionsModal.vue?vue&type=template&id=201a045a"
import script from "./PeddlrOptionsModal.vue?vue&type=script&lang=js"
export * from "./PeddlrOptionsModal.vue?vue&type=script&lang=js"
import style0 from "./PeddlrOptionsModal.vue?vue&type=style&index=0&id=201a045a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports